'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _handlers = require('./utils/sub-components/handlers');

var _handlers2 = _interopRequireDefault(_handlers);

var _controlButtons = require('./utils/sub-components/control-buttons');

var _slideTrack = require('./utils/sub-components/slide-track');

var _valueUtils = require('./utils/value-utils');

var _ticks = require('./utils/sub-components/ticks');

var _keyboardInteractionHelper = require('./utils/keyboard-interaction-helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);

var defaultProps = {
  rootClassName: 'zippy-react-toolkit-slider',
  orientation: 'horizontal',

  startValue: 0,
  endValue: 100,

  step: 1,
  largeStep: 10,

  statefulDrag: true,

  enableTrackClick: true,

  handleSize: {
    width: 14,
    height: 14
  },

  toStep: _valueUtils.valueToStep,
  theme: 'default',
  tickLabels: true,

  renderTickLabel: _ticks.renderTickLabel,
  renderHandleContent: _handlers.renderHandleContent,
  tabIndex: 0,

  trackStyle: {},
  trackLineStyle: {},
  trackFillStyle: {},

  trackFillPosition: 'start',
  tickBarPosition: 'end',

  renderIncrementButton: _controlButtons.renderIncrementButton,
  renderDecrementButton: _controlButtons.renderDecrementButton,

  incrementButton: _react2.default.createElement(
    'svg',
    { width: '16', height: '16', viewBox: '0 0 20 21' },
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M11,6 L9,6 L9,10 L5,10 L5,12 L9,12 L9,16 L11,16 L11,12 L15,12 L15,10 L11,10 L11,6 L11,6 Z M10,1 C4.48,1 0,5.48 0,11 C0,16.52 4.48,21 10,21 C15.52,21 20,16.52 20,11 C20,5.48 15.52,1 10,1 L10,1 Z M10,19 C5.59,19 2,15.41 2,11 C2,6.59 5.59,3 10,3 C14.41,3 18,6.59 18,11 C18,15.41 14.41,19 10,19 L10,19 Z'
    })
  ),

  decrementButton: _react2.default.createElement(
    'svg',
    { width: '16', height: '16', viewBox: '0 0 20 21' },
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5,10 L5,12 L15,12 L15,10 L5,10 Z M10,1 C4.48,1 0,5.48 0,11 C0,16.52 4.48,21 10,21 C15.52,21 20,16.52 20,11 C20,5.48 15.52,1 10,1 L10,1 Z M2,11 C2,6.59 5.59,3 10,3 C14.41,3 18,6.59 18,11 C18,15.41 14.41,19 10,19 C5.59,19 2,15.41 2,11 Z'
    })
  ),

  shiftDelay: 45,

  tickStep: 50,
  tickStyle: {},

  smallTickStep: 10,

  tooltipPosition: 'before',
  tooltipVisibility: 'onInteraction',

  updateValueOnTrackDrag: false,

  renderTrack: _slideTrack.renderTrack,
  renderHandle: _handlers2.default,
  renderTickContent: _ticks.renderTickContent,
  renderTooltipContent: _handlers.renderTooltipContent,
  getValueModifier: _keyboardInteractionHelper.getValueModifier,
  renderTooltip: _handlers.renderTooltip,
  shouldShowTooltip: _handlers.shouldShowTooltip
};

var propTypes = {
  rootClassName: _propTypes2.default.string,
  startValue: _propTypes2.default.number.isRequired,
  endValue: _propTypes2.default.number.isRequired,

  value: _propTypes2.default.number,
  defaultValue: _propTypes2.default.number,

  step: _propTypes2.default.number,
  largeStep: _propTypes2.default.number,

  toStep: _propTypes2.default.func,

  minRange: _propTypes2.default.number,
  maxRange: _propTypes2.default.number,

  onDrag: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onDragEnd: _propTypes2.default.func,
  onDragStart: _propTypes2.default.func,

  statefulDrag: _propTypes2.default.bool,

  tickStep: _propTypes2.default.number,
  smallTickStep: _propTypes2.default.number,
  ticks: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number])),

  tickStyle: _propTypes2.default.object,

  trackFillStyle: _propTypes2.default.object,
  trackStyle: _propTypes2.default.object,
  trackLineStyle: _propTypes2.default.object,

  renderTickContent: _propTypes2.default.func,
  renderTickLabel: _propTypes2.default.func,

  handleSize: _propTypes2.default.object,
  handleStyle: _propTypes2.default.object,
  renderHandleContent: _propTypes2.default.func,
  renderTooltipContent: _propTypes2.default.func,

  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),

  theme: _propTypes2.default.string,
  tickLabels: _propTypes2.default.bool,

  tabIndex: _propTypes2.default.number,
  noFill: _propTypes2.default.bool,

  trackFillPosition: _propTypes2.default.oneOf(['start', 'end']),
  tickBarPosition: _propTypes2.default.oneOf(['start', 'end', 'both', 'none']),

  rtl: _propTypes2.default.bool,
  skipEdgeTicks: _propTypes2.default.bool,

  showButtons: _propTypes2.default.bool,
  renderIncrementButton: _propTypes2.default.func,
  renderDecrementButton: _propTypes2.default.func,
  incrementButton: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  decrementButton: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  shiftDelay: _propTypes2.default.number,
  enableTrackClick: _propTypes2.default.bool,

  tooltipPosition: _propTypes2.default.oneOf(['before', 'after']),
  tooltipVisibility: _propTypes2.default.oneOf(['always', 'never', 'onInteraction']),

  renderTrack: _propTypes2.default.func,
  getValueModifier: _propTypes2.default.func,
  renderTooltip: _propTypes2.default.func,
  renderHandle: _propTypes2.default.func,
  shouldShowTooltip: _propTypes2.default.func,

  updateValueOnTrackDrag: _propTypes2.default.bool
};

exports.defaultProps = defaultProps;
exports.propTypes = propTypes;